import GalleryComp from "../components/Gallery"

const Gallery = () => {


    return (
        <div>
            <h2>Gallery Page</h2>
            <GalleryComp />
        </div>
    )
}

export default Gallery